'use client';

import { useState } from 'react';
import { Plus } from 'lucide-react';
import { useTranslations } from 'next-intl';

import styles from './AuditFAQ.module.css';

const FAQ_COUNT = 9;

export function AuditFAQ() {
  const t = useTranslations('audit.faq');
  const [openId, setOpenId] = useState<number>(1); // First item open by default

  const toggleFAQ = (id: number) => {
    setOpenId(openId === id ? 0 : id);
  };

  return (
    <section className={styles.section} id="faq">
      <div className={styles.container}>
        <div className={styles.header}>
          <span className={styles.label}>{t('label')}</span>
          <h2 className={styles.title}>{t('title')}</h2>
        </div>

        <div className={styles.faqList}>
          {Array.from({ length: FAQ_COUNT }, (_, i) => i + 1).map((id) => (
            <div key={id} className={`${styles.faqItem} ${openId === id ? styles.active : ''}`}>
              <button
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(id)}
                aria-expanded={openId === id}
                aria-controls={`faq-answer-${id}`}
              >
                <span className={styles.questionText}>{t(`q${id}`)}</span>
                <Plus className={`${styles.faqIcon} ${openId === id ? styles.rotated : ''}`} size={20} strokeWidth={2} />
              </button>
              <div
                id={`faq-answer-${id}`}
                className={`${styles.faqAnswer} ${openId === id ? styles.open : ''}`}
                role="region"
              >
                <p>{t(`a${id}`)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
